import { useI18n } from "@/i18n/I18nProvider";

const sectors = [
  "stable",
  "stable",
  "watched",
  "stable",
  "warning",
  "watched",
  "stable",
  "warning",
  "infected",
  "watched",
  "stable",
  "infected",
  "warning",
  "stable",
  "watched",
  "infected"
];

export function WorldPulse() {
  const { t } = useI18n();

  return (
    <div className="world-pulse" data-reveal>
      <div className="pulse-map" aria-hidden="true">
        {sectors.map((sector, index) => (
          <span className={`pulse-sector ${sector}`} key={`${sector}-${index}`} />
        ))}
      </div>
      <div className="pulse-copy">
        <span>{t("home.hero.signal1")}</span>
        <strong>82%</strong>
        <span>{t("home.hero.signal2")}</span>
        <strong>Level 2</strong>
        <span>{t("home.hero.signal3")}</span>
        <strong>17%</strong>
      </div>
    </div>
  );
}
